import { render, staticRenderFns } from "./editOrAddRoutes.vue?vue&type=template&id=09593d03&scoped=true"
import script from "./editOrAddRoutes.vue?vue&type=script&lang=js"
export * from "./editOrAddRoutes.vue?vue&type=script&lang=js"
import style0 from "./editOrAddRoutes.vue?vue&type=style&index=0&id=09593d03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09593d03",
  null
  
)

export default component.exports